var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewProductList1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7H13V9H22V7Z",
    fill: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 15H13V17H22V15Z",
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H16V13H22V11Z",
    fill: "#C6C6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12L8 7V11H2V13H8V17L13 12Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewProductList1);
export default __webpack_public_path__ + "static/media/View_product_list_1.3cf1114858535dec3535cc092e731e75.svg";
export { ForwardRef as ReactComponent };